import React, { useContext, useEffect } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import { SocketContext } from "../Context";

const useStyles = makeStyles((theme) => ({
  videoSection: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px",
    background: "#202124",
    minHeight: "calc(100vh - 60px)",
    [theme.breakpoints.down("md")]: {
      minHeight: "auto",
      padding: "8px",
      maxHeight: "none",
    },
    "@media (orientation: landscape) and (max-width: 960px)": {
      minHeight: "auto",
      padding: "6px",
      maxHeight: "none",
    },
  },
  gridContainer: { maxWidth: "1600px", width: "100%", margin: "0 auto" },
  videoCard: {
    position: "relative",
    background: "#000",
    borderRadius: "10px",
    overflow: "hidden",
    aspectRatio: "16/9",
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
    border: "1px solid #3c4043",
    width: "100%",
  },
  myVideoCard: { border: "1px solid #5f6368", transform: "scale(0.9)", transformOrigin: "center" },
  video: { width: "100%", height: "100%", objectFit: "cover", display: "block" },
  placeholderCard: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#e8eaed",
    fontSize: "16px",
    fontWeight: 600,
    background: "linear-gradient(135deg, #1f1f1f 0%, #2c2c2c 100%)",
  },
  nameOverlay: {
    position: "absolute",
    bottom: "8px",
    left: "8px",
    background: "rgba(0,0,0,0.7)",
    color: "#fff",
    padding: "4px 8px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: 600,
    zIndex: 10,
  },
}));

const VideoPlayer = () => {
  const { name, callAccepted, myVideo, userVideo, callEnded, stream, call } = useContext(SocketContext);
  const c = useStyles();

  useEffect(() => {
    if (myVideo.current && stream && myVideo.current.srcObject !== stream) {
      myVideo.current.srcObject = stream;
      myVideo.current.play?.().catch(() => {});
    }
  }, [stream, myVideo]);

  return (
    <div className={c.videoSection}>
      <Grid container className={c.gridContainer} spacing={1}>
        {stream && (
          <Grid item xs={12} sm={4} md={4}>
            <div className={`${c.videoCard} ${c.myVideoCard}`}>
              <video playsInline muted ref={myVideo} autoPlay className={c.video} />
              <div className={c.nameOverlay}>{name || "Du"}</div>
            </div>
          </Grid>
        )}

        {callAccepted && !callEnded && (
          <Grid item xs={12} sm={8} md={8}>
            <div className={c.videoCard}>
              <video playsInline ref={userVideo} autoPlay className={c.video} />
              <div className={c.nameOverlay}>{call.name || "Deltagare"}</div>
            </div>
          </Grid>
        )}

        {!callAccepted && !callEnded && (call?.isReceivingCall || call?.name) && (
          <Grid item xs={12} sm={8} md={8}>
            <div className={c.videoCard}>
              <div className={c.placeholderCard}>{call?.name || "Deltagare"} ansluter...</div>
              <div className={c.nameOverlay}>{call?.name || "Deltagare"}</div>
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default VideoPlayer;
